import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../apis/auth";
import useModal from "../../hooks/useModal";
import { setAdminAuthenticated, setLogout } from "../../redux/userSlice";
import ConfirmationModal from "../Modals/ConfirmationModal";

const LogoutButton = ({ styled, adminLogout }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isShowing, toggle } = useModal();

  const handleLogout = async (event) => {
    if (!event) return;
    if (adminLogout) {
      dispatch(setAdminAuthenticated(false));
      return;
    }
    const response = await logout();
    if (response.status === "success") {
      toast.success("Logout Successful");
      dispatch(setLogout({}));
      toggle();
      navigate("/");
    } else {
      toast.error("Logout Failed");
    }
  };

  return (
    <>
      <button
        className={`font-medium ${
          styled
            ? "text-white bg-red-500 hover:bg-red-600 text-white rounded-full px-7 py-2"
            : "text-red-700"
        }`}
        type="button"
        onClick={() => toggle()}
      >
        Logout
      </button>
      <ConfirmationModal
        title={"Are you sure you want to logout?"}
        isOpen={isShowing}
        onClose={toggle}
        onConfirm={handleLogout}
      ></ConfirmationModal>
    </>
  );
};

export default LogoutButton;
